// extracted by mini-css-extract-plugin
module.exports = {"search":"style_search__2Asvz","page-header__actions":"style_page-header__actions__1ldUV"};